import React from 'react'
import CountdownTimer from './CountdownTimer.js'
// import CountdownTimer from 'react-component-countdown-timer'
import 'react-component-countdown-timer/lib/styles.css'

class QuizCountdownTimer extends React.Component {
	state = {
		color: '#27bf65',
	}
	getRedColor = () => {
		this.setState({ color: 'red' })
	}
	render() {
		const settings = {
			count: this.props.quizCount,
			border: true,
			showTitle: true,
			noPoints: true,
			hideDay: true,
			direction: 'right',
			color: this.state.color,
		}
		return (
			<CountdownTimer
				className='root'
				{...settings}
				onEnd={this.props.onEndCount}
				onUnmount={this.props.onUnmount}
				getRedColor={this.getRedColor}
			/>
		)
	}
}
export default QuizCountdownTimer
